module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAUVBMVEUAAAAzMzMzMzMyMjIyMjIzMzMyMjIzMzMyMjIzMzMzMzMzMzMyMjIzMzMzMzMzMzMyMjI0NDQzMzM1NTUzMzMyMjIzMzMyMjIxMTEyMjIzMzP65CLRAAAAGnRSTlMAVaqAf+tPRzb55do79fDgcUAyEb+4iGYsJI2DtyQAAABxSURBVEjH7ctJDoAgEAVREEEQVBTHvv9BDZ6Av+hEg7V+JT5YXI+E+IaIDOgpgp4u0EvMO8PrB9R3mB+ZvUb9jPke9YHXT5bNb9n7cu8fvxT7kL3OvjSXjxYYdkIPWfmh/qO6w6KHEsihiU6BlJR4ezdJYBSjLfr66AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/demo1/source/back.png
// module id = y5Lj
// module chunks = 1